<div class="dasboard-width" >
    <div class="row header mar-lft-rgt-0">
        <div class="col-sm-2 pad-0">
            <div class="page-title" style="margin: 0px 0px;">
                <ol class="breadcrumb no-background">
                    <li class="active"><i class="fa fa-tachometer"></i> <span class="blue">i</span><span class="red">FIX</span>
                        Dashboard
                    </li>
                </ol>
            </div>
        </div>
        <div class="col-sm-2">
            <!--<button type="button" class="btn btn-warning radius-0" (click)="filter()">Filter</button>-->
        </div>
        <div class="col-sm-2">
            <mat-form-field [hidden]="!isLabel3">
                <mat-label>User:</mat-label>
                <mat-select [(ngModel)]="userSelected" (selectionChange)="onSelectUser()" class="matSize">
                    <mat-option *ngFor="let user of users" [value]="user.id" class="matSize"
                    >{{user.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-2">
            <!--<mat-form-field [hidden]="isLabel0">-->
                <!--<mat-label>Team:</mat-label>-->
                <!--<mat-select [(ngModel)]="categorySelected" (selectionChange)="onSelectCategory()" class="matSize">-->
                    <!--<mat-option *ngFor="let category of categories" [value]="category.id" class="matSize"-->
                    <!--&gt;{{category.name}}</mat-option>-->
                <!--</mat-select>-->
            <!--</mat-form-field>-->
        </div>
        <div class="col-sm-2">
            <mat-form-field>
                <mat-label>Current Role:</mat-label>
                <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()" class="matSize">
                    <mat-option *ngFor="let group of userGroups" [value]="group.groupId" class="matSize"
                    >{{group.grpName}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <ng-template #content let-c="close" let-d="dismiss">
        <!--    <div class="modal-body">-->
        <!--      <app-chart></app-chart>-->
        <!--    </div>-->
    </ng-template>
    <div class="dashboard-content mr-top-5">
        <div class="row mar-lft-rgt-0 font-16">
            <div class="col-sm-9 pad-15">
                <div class="height-40" [hidden]="ticketTypeLoaded">
                    <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                </div>
                <mat-radio-group (change)="onButtonChange($event)" [hidden]="!ticketTypeLoaded">
                    <!--<div *ngFor="let button of radioButton;">-->
                    <mat-radio-button *ngFor="let button of radioButton;" [value]="button"
                                      [checked]="button.checked">{{button.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button>&nbsp;&nbsp;
                    <!--</div>-->
                </mat-radio-group>
            </div>

            <!--      <div class="col-sm-2 pad-15">-->
            <!--        &lt;!&ndash;font-13 radius-0&ndash;&gt;-->
            <!--        <button type="button" class="btn btn-warning radius-0 refresh-btn matRipple" (click)="onPageLoad()" title="refresh"> <mat-icon>refresh</mat-icon></button>-->
            <!--      </div>-->
            <div class="col-sm-3">
                <mat-form-field class="right mar-lft-9">
                    <mat-label>Workspace:</mat-label>
                    <mat-select [(ngModel)]="workType" (selectionChange)="onWorkTypeChange()">
                        <mat-option *ngFor="let wp of workspaces" [value]="wp.id"
                        >{{wp.name}}</mat-option>
                        <!--            <mat-option value="1">My Workspace</mat-option>-->
                        <!--            <mat-option value="2">Team Workspace</mat-option>-->
                    </mat-select>
                </mat-form-field>
                <button type="button" class="btn btn-warning radius-0 refresh-btn matRipple right" (click)="onPageLoad()" title="refresh"> <mat-icon>refresh</mat-icon></button>
            </div>
        </div>
        <ng-template #content let-c="close" let-d="dismiss">
            <!--      <div class="modal-body">-->
            <!--        <app-chart [chartRadius]="radius" ></app-chart>-->
            <!--      </div>-->
        </ng-template>
        <ng-template #clientSelect>
            <div class="form-group">
                <select class="custom-select radius-0 font-13" [(ngModel)]="clientSelected"
                        (change)="onSubClientChange()">
                    <option *ngFor="let client of subClients" [value]="client.id">{{client.NAME}}</option>
                </select>
            </div>
            <div class="form-group">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected" (change)="onGroupChange($event.target.selectedIndex)">
                    <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
                </select>
            </div>
            <button class="btn btn-success radius-0 font-13" (click)="getSubClientDetails()" [disabled]="!allSelected">Submit
            </button>
        </ng-template>
        <div class="row mar-lft-rgt-0">
            <!--<div class="col-md-3 col-sm-6 chartBox mr-lft-5" (click)="chartDetails()">-->
            <!--<div class="chart-style">-->
            <!--<app-chart *ngIf="hideChart" [chartRadius]="radius"></app-chart>-->
            <!--</div>-->
            <!--</div>-->
            <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="showCreateTicket">
                <div class="card card-style create-ticket-bg shadow border-0 pointer" matRipple (click)="createTicket()">
                    <div class="card-body pad-0">
                        <h1 class="card-text static-card">Create Ticket</h1>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="showScheduleTicket">
                <div class="card card-style autoticket-bg shadow border-0 pointer" matRipple (click)="goToScheduleTicket()">
                    <div class="card-body pad-0">
                        <h1 class="card-text static-card">Schedule Ticket</h1>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLoading">
                <div class="card card-style shadow border-0">
                    <div class="card-body pad-0">
                        <img class="loading-gif-70" src="../../../assets/img/loader-70px.gif">
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-sm-3 mar-top-15" *ngFor="let data of tilesData" (click) = "goto(data.fid)">
                <div class="card card-style half shadow border-0 pointer" matRipple>
                    <div class="card-top" [ngStyle]="{'background-color': data.color_code}">

                        <h4 class="card-text top-part top-tesxtarea">{{data.funcDescription}}
                            <mat-icon color="black" class="none" id="display_{{data.fid}}">grade</mat-icon>
                        </h4>
                    </div>
                    <div class="card-buttom">
                        <img id="loader_{{data.fid}}" src="../../../assets/img/elipsis_loader.gif">
                        <h1 class="card-text buttom-number" id="count_{{data.fid}}"></h1>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="showSearch">
                <div class="card card-style search-bg shadow border-0 pointer" matRipple (click)="goToSearch()">
                    <div class="card-body pad-0">
                        <h1 class="card-text static-card">Search Ticket</h1>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="showFaq">
                <div class="card card-style faq-bg shadow border-0 pointer" matRipple (click)="goTofaq()">
                    <div class="card-body pad-0">
                        <h1 class="card-text static-card">KM</h1>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>